export class ApiUrl {
  static readonly File = "file";
  static readonly User = "api/user/foreigner-login";
  static readonly ForcePassword = "api/user/force-password";
  static readonly ForgetPassword = "api/user/forget-password";
  static readonly ValidateToken = "api/user/validate-token";
  static readonly ValidateResetPasswordToken = "api/user/validate-resetpassword-token";
  static readonly ResetPassword = "api/user/reset-password";
  static readonly Auth = "auth";
  static readonly Alert = "alert";
  static readonly FileValidation = "photovalidation";
  static readonly SPAuthSettings = "api/authsp/oidc-configurations";
  static readonly CPAuthSettings = "api/authcp/oidc-configurations";
  static readonly MIAuthSettings = "api/authmi/mi-configurations";
  static readonly CPOidcDoscoveryEndpoint =
    "api/authcp/oidc-discovery-endpoint";
  static readonly SPOidcDiscoveryEndpoint =
    "api/authsp/oidc-discovery-endpoint";
  static readonly CreateUserSession = "api/usersession/createusersession";
  static readonly ValidateUserToken = "api/usersession/validatetoken";
  static readonly LogoutSession = "api/user/logout";
  static readonly Token = "api/authsp/token";
  static readonly CPToken = "api/authcp/token";
  static readonly QRCodeVerify = "api/user/qr-link";
  static readonly SPJwk = "api/authsp/jwk";
  static readonly CPJwk = "api/authcp/jwk";
  static readonly MyInfoToken = "api/authmi/token";
  static readonly CreateSfaUser = "api/sfa/create-sfa-user";
  static readonly CreateEservicesUser = "api/account/create-user";
  static readonly CreateForeignerUser = "api/auth/foreigner-login";
  static readonly CreateForgetPassword = "api/auth/forget-password";
}

export class PageUrl {
  static readonly Home = "/";
  static readonly Login = "/login";
  static readonly CPLogin = "/cp-login";
  static readonly MILogin = "/mi-login";
  static readonly CPJwks = "/cp-jwk";
  static readonly CPCallback = "/cp-callback";
  static readonly MICallback = "/mi-callback";
  static readonly Auth = "/auth";
  static readonly SfaRegistration = "/sfa-registration";
  static readonly SfaSuccess = "/sfa-success";
  static readonly AccountRegistration = "/account-registration";
  static readonly AccountSuccess = "/account-success";
  static readonly Profile = "/profile";
  static readonly ForceChangePassword = "/force-change-password";
  static readonly ResetPassword = "/reset-password";
  static readonly ForgetPassword = "/forget-password";
  static readonly Userguide = "/userguides";
}

export enum NotifyType {
  Info,
  Warning,
  Success,
  Error,
}

export enum ErrMsg {
  BiosurveillancePurposeofTestErrMsg = "You cannot proceed with a purpose of test other than Biosurveillance since the payment mode is Biosurveillance. Please change the payment mode or edit the purpose of the test in step 2.",
  ExchangeofServiceErrMsg = "The balance amount under the Exchange of Services Agreement is below",
  BiosurveillancepaymentmodeErrMsg = "You cannot proceed with Biosurveillance as the purpose of the test with other than Biosurveillance as the payment mode. Please select Biosurveillance as the payment mode or edit the purpose of the test in step 2.",
  InternalServerErrMsg = "Oops! Something went wrong. Please contact NParks for support.",
}

export class SessionKey {
  static readonly AuthToken = "auth-token";
  static readonly AppData = "app-data";
  static readonly AccessToken = "access_token";
}
